/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Sesso } from './sesso';


/**
 * Profilo identita\' persona dell\'utente autenticato.
 */
export interface UserProfileDTO { 
    id?: string;
    version?: number;
    nome?: string;
    cognome?: string;
    codice_fiscale?: string;
    sesso?: Sesso;
    data_nascita?: string;
    comune_nascita?: string;
    provincia_nascita?: string;
    nazione_nascita?: string;
    indirizzo_residenza?: string;
    comune_residenza?: string;
    provincia_residenza?: string;
    cap_residenza?: string;
    cellulare?: string;
    telefono_fisso?: string;
    email?: string;
}



